var _ellipse, _path, _path2, _ellipse2, _ellipse3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlant2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 210,
    viewBox: "0 0 150 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 79.0485,
    cy: 202.974,
    rx: 36.1511,
    ry: 6.1165,
    fill: "#042A44"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.9581 188.314L51.6077 158.235C51.5565 158.021 51.5303 157.794 51.5303 157.566C51.5303 156.464 52.1288 155.571 52.8672 155.571H105.229C105.382 155.571 105.533 155.61 105.677 155.686C106.373 156.056 106.736 157.197 106.488 158.235L102.138 188.314C102.138 188.314 102.25 202.974 79.5878 202.974C56.926 202.974 55.9581 188.314 55.9581 188.314Z",
    fill: "#9F9E8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9581 188.314L51.6077 158.235C51.5565 158.021 51.5303 157.794 51.5303 157.566C51.5303 156.464 52.1288 155.571 52.8672 155.571H105.229C105.382 155.571 105.533 155.61 105.677 155.686C106.373 156.056 106.736 157.197 106.488 158.235L102.138 188.314C102.138 188.314 99.5519 198.896 79.5878 198.896C59.6238 198.896 55.9581 188.314 55.9581 188.314Z",
    fill: "#C0BFB4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.0486,
    cy: 157.1,
    rx: 27.518,
    ry: 6.1165,
    fill: "#9F9E8F"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.0491,
    cy: 159.139,
    rx: 24.2806,
    ry: 4.07767,
    fill: "#32312B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.661 43.7221L126.883 40.4238L136.79 47.319C130.167 55.545 123.287 64.4175 122.651 74.9037C122.437 78.3223 121.989 81.5633 121.257 84.5955L106.164 87.6818L102.233 88.4842L107.273 88.8814L119.701 89.8701C118.831 92.2842 117.809 94.5533 116.613 96.6519C111.04 106.531 101.252 135.216 90.5972 136.82C90.5972 136.82 90.5972 136.82 90.5877 136.82C90.2613 136.204 74.996 107.925 89.0906 64.6778C90.9665 58.9398 93.4439 53.5912 96.3325 48.6645C96.4277 48.495 96.5218 48.3402 96.6171 48.1786C113.732 19.3716 144.762 5.40967 149.011 20.0931C151.341 28.1229 146.087 35.6835 139.661 43.7221Z",
    fill: "#3A8761"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.613 96.6523C108.21 122.089 101.252 135.216 90.597 136.821C90.597 136.821 90.597 136.821 90.5876 136.821C90.1576 136.821 66.8082 136.505 87.1225 67.384C88.8247 61.5977 93.315 53.7533 96.3323 48.6649C96.4275 48.4954 96.5217 48.3406 96.6169 48.179C95.6962 55.4635 95.2756 66.3144 98.6643 76.1432C98.6643 76.1432 100.994 81.6781 106.164 87.6821L102.233 88.4845L107.273 88.8818C109.775 91.5965 112.872 94.3595 116.613 96.6523Z",
    fill: "#2A5B43"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.5866 71.2163L86.5613 77.1849L93.7477 75.1336C94.2896 95.8705 90.3161 115.583 79.6396 117.402C65.4749 119.833 57.5436 84.228 57.0519 59.151L67.1771 61.639L57.1429 55.3904C57.191 53.832 57.2852 49.3094 57.416 47.9255C58.8168 33.174 64.0814 18.1376 73.5266 8.77417C79.4052 17.9365 84.426 28.4898 87.981 38.9415C90.9669 47.6711 92.9714 59.4388 93.5866 71.2163Z",
    fill: "#3A8761"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.4097 47.9216L87.9821 38.9337C84.4375 28.4908 79.3979 17.9385 73.5255 8.77417C64.0876 18.1327 58.8074 33.1789 57.4097 47.9216Z",
    fill: "#2A5B43"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3888 47.9255C62.3112 39.0599 70.2687 34.8932 78.8006 32.0129L76.1767 18.5143L82.3483 30.8911C95.0608 27.1266 108.405 25.1699 114.898 14.3614C116.436 11.8113 115.21 8.61655 112.969 6.55637C110.885 4.63124 107.974 2.91113 104.561 1.7253L89.4217 6.03097L97.7925 0.20136C82.0982 -1.57789 61.5904 7.95808 57.3888 47.9255Z",
    fill: "#89B59F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7185 131.8C57.6418 134.915 44.0682 118.36 33.6333 96.675C33.04 95.4103 32.4448 94.1456 31.8516 92.8405C30.7279 90.3505 29.6461 87.8004 28.6303 85.2109L35.1471 84.2114L26.6602 80.0112C22.0852 67.2036 19.0878 53.9169 19.1086 42.5623L50.3559 48.453C57.7872 59.9427 63.8458 75.9027 67.4364 90.8148L64.2256 99.5376L68.7253 96.6158C72.2887 114.336 71.9623 129.403 65.7185 131.8Z",
    fill: "#2A5B43"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.356 48.453C50.356 48.453 43.5839 47.3006 36.522 51.2544L25.6068 45.6151L34.0445 52.8779C32.0714 54.3447 30.1359 56.2521 28.3709 58.7765C28.168 59.0634 27.965 59.3315 27.762 59.6184C25.204 57.7908 21.8436 55.5276 21.5172 55.3166L25.4394 62.6416C12.9476 77.5853 -3.27704 80.8628 0.578257 66.3292C1.36815 63.3543 2.09841 59.9367 3.34863 56.0835L11.0331 51.0474L4.71498 52.0292C5.16172 50.8118 5.32597 50.5043 5.74969 49.8281C9.48572 43.9906 16.487 40.7406 23.7205 41.057C32.7901 41.475 45.9682 43.0107 50.356 48.453Z",
    fill: "#89B59F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M133.545 22.5361C121.939 34.6643 96.193 58.9208 86.0635 159.138",
    stroke: "#89B59F",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0342 30.6914C76.5477 64.5683 84.2206 137.889 78.8044 160.157",
    stroke: "#89B59F",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9482 53.1191C41.6029 70.479 65.6893 115.987 68.7972 159.139",
    stroke: "#89B59F",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlant2);
export default __webpack_public_path__ + "static/media/plant2.c7df6fa2f3e1612a117dfce7d90db1a6.svg";
export { ForwardRef as ReactComponent };